
import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTipoFichaList, modifyTipoFicha, removeTipoFicha, addTipoFicha, updateTipoFichaListDB } from '../../actions/tipo_ficha_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoFicha extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTipoFichaList();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkTipoFicha = (tipoFicha) => {
        if (this.props.tipoFichaList.find(c => (c.descr === tipoFicha.descr) && (c.id !== tipoFicha.id))) {
            this.messageDialog(`Ya existe un tipo de ficha con descripción ${tipoFicha.descr}`);
            return false;
        } else if (!tipoFicha.descr.trim()) {
            this.messageDialog('Por favor, introduzca una Descripción');
            return false;
        }

        else return true;
    };

    addNewTipoFicha = (tipoFicha) => {
        this.props.setSaveState(true);
        this.props.addTipoFicha(tipoFicha);
    };

    newTipoFicha = () => {
        this.props.openDialog('EditTipoFicha', {
            tipoFicha: {},
            okHandler: this.addNewTipoFicha,
            checkTipoFicha: this.checkTipoFicha,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.props.tipoFichaList[i], { $merge: updated });
            if (this.checkTipoFicha(updatedRow)) {
                this.props.setSaveState(true);
                this.props.modifyTipoFicha(updatedRow);
            }
        };

    };

    handleDeleteRow = (tipoFicha) => {
        this.props.setSaveState(true);
        this.props.removeTipoFicha(tipoFicha);
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                        <NeuriteGrid
                            id="m_r_t_f"
                            columns={[
                                { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 155 },
                            ]}
                            rows={this.props.tipoFichaList}
                            height={500}
                            buttonEdit={false}
                            buttonDelete={true}
                            buttonNew={true}
                            onNewRowClick={this.newTipoFicha}
                            onRowsUpdated={this.handleGridRowsUpdated}
                            onDeleteClick={this.handleDeleteRow}
                        />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tipoFichaList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTipoFichaListDB(this.props.tipoFichaList)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresTipoFicha.propTypes = {
    //state
    tipoFichaList: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTipoFichaList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoFicha: PropTypes.func.isRequired,
    removeTipoFicha: PropTypes.func.isRequired,
    addTipoFicha: PropTypes.func.isRequired,
    updateTipoFichaListDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tipoFichaList: state.tipoFicha.tipoFichaList,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTipoFichaList,
        openDialog,
        hideDialog,
        modifyTipoFicha,
        removeTipoFicha,
        addTipoFicha,
        updateTipoFichaListDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoFicha));